import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { placeHolderImage } from "./EventCard";

const WikiAdvocateList = (props) => {
  return (
    <ul>
      {props.advocates &&
        props.advocates.length > 0 &&
        props.advocates.map((visitor) => {
          return (
            <li key={visitor.id}>
              <div className="eventVisitorFull">
                <div className="one">
                  <img
                    src={
                      visitor.thumbnailUrl && visitor.thumbnailUrl !== "None"
                        ? visitor.thumbnailUrl
                        : placeHolderImage
                    }
                    alt="images"
                  />
                </div>
                <div className={`two ${props.superAdmin ? "" : "full-width"}`}>
                  <Link to={`/about`} target="_blank">
                    <p>{visitor.name}</p>
                  </Link>
                </div>
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default WikiAdvocateList;
